import React, { useEffect, useRef, useState } from 'react';
import styles from './Hero.module.css';
import CampaignModal from '../CampaignModal/CampaignModal';

const Hero = () => {
  const [animationKey, setAnimationKey] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Reset animation by first hiding, then showing
            setIsVisible(false);
            setTimeout(() => {
              setAnimationKey(prev => prev + 1);
              setIsVisible(true);
            }, 50);
          } else {
            setIsVisible(false);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    // Trigger on initial load
    setTimeout(() => {
      setAnimationKey(1);
      setIsVisible(true);
    }, 100);

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  return (
    <section id="home" className={styles["hero"]} ref={heroRef}>
      <div className={styles["hero-container"]}>
        <div className={styles["hero-content"]}>
          <h1 className={styles["hero-title"]}>
            <span className={styles["title-line-1"]}>Bring Your Favorite Photos to Life.</span>
            <br />
            Stop Burying Them.
          </h1>
          <p className={styles["hero-subtitle"]}>
            LifeInPXL, An e-ink album that shuffles through your favorite photos.
          </p>
          
          <div className={styles["hero-features"]}>
            <div className={styles["feature-item"]}>
              <span className={styles["checkmark"]}>✓</span>
              <span>500+ photos storage</span>
            </div>
            <div className={styles["feature-item"]}>
              <span className={styles["checkmark"]}>✓</span>
              <span>Fits anywhere: desk, fridge, bedside</span>
            </div>
            <div className={styles["feature-item"]}>
              <span className={styles["checkmark"]}>✓</span>
              <span>Charge once for 1 year use</span>
            </div>
          </div>

          <button 
            className={styles["cta-button"]}
            onClick={() => setIsModalOpen(true)}
          >
            See the Kickstarter campaign
          </button>
        </div>
        
        <div className={styles["hero-image"]}>
          <div className={styles["image-frames-container"]} key={animationKey}>
            <div 
              className={`${styles["image-frame"]} ${styles["frame-1"]} ${isVisible ? styles["animate-in"] : ""}`}
            >
              <img 
                src="/assets/FBE7476F-D7B4-41FB-8890-CD8D235ADDB3.JPEG" 
                alt="LifeInPXL product showcase" 
                className={styles["frame-image"]}
              />
            </div>
            <div 
              className={`${styles["image-frame"]} ${styles["frame-2"]} ${isVisible ? styles["animate-in"] : ""}`}
            >
              <img 
                src="/assets/FBE7476F-D7B4-41FB-8890-CD8D235ADDB3.JPEG" 
                alt="LifeInPXL product showcase" 
                className={styles["frame-image"]}
              />
            </div>
            <div 
              className={`${styles["image-frame"]} ${styles["frame-3"]} ${isVisible ? styles["animate-in"] : ""}`}
            >
              <img 
                src="/assets/FBE7476F-D7B4-41FB-8890-CD8D235ADDB3.JPEG" 
                alt="LifeInPXL product showcase" 
                className={styles["frame-image"]}
              />
            </div>
          </div>
        </div>
      </div>
      <CampaignModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </section>
  );
};

export default Hero;

